import React, { useContext } from 'react'
import { PartsContext } from './App'

export default function PartEdit({ part }) {
  const { handlePartChange, handlePartSelect } = useContext(PartsContext)

  function handleChange(changes) {
    handlePartChange(part.id, { ...part, ...changes })
  }

  return (
    <div className="parts-edit">
      <div className="parts-edit__remove-button-container">
        <button 
          className="btn parts-edit__remove-button"
          onClick={() => handlePartSelect(undefined)}
          >
          &times;
        </button>
      </div>

      <div className="parts-edit__details-grid">   
        <label
          htmlFor="nomenclature"
          className="parts-edit__label">
          Nomenclature
        </label>
        <input 
          type="text" 
          name="nomenclature" 
          id="nomenclature"
          value={part.nomenclature}
          onChange={e => handleChange({ nomenclature: e.target.value })}
          className="parts-edit__input" 
        />

        <label 
          htmlFor="stockNumber"
          className="parts-edit__label">
          Stock Number
        </label>
        <input 
          type="text" 
          name="stockNumber" 
          id="stockNumber"
          value={part.stockNumber}
          onChange={ e => handleChange({ stockNumber: e.target.value }) }
          className="parts-edit__input" 
        />

        <label 
          htmlFor="location"
          className="parts-edit__label">
          Location
        </label>
        <input 
          type="text" 
          name="location" 
          id="location"
          value={part.location}
          onChange={ e => handleChange({ location: e.target.value }) }
          className="parts-edit__input" 
        />

        <label
          htmlFor="reference"
          className="parts-edit__label">
          Reference
        </label>
        <textarea
          name="reference"
          className="parts-edit__input"
          onChange={ e => handleChange({ reference: e.target.value })}
          value={part.reference} 
          id="reference" />
      </div>
    </div>
  )
}
